"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationUtils = void 0;
class ValidationUtils {
    static isBlankString(str) {
        return (!str || str.trim().length === 0);
    }
    static isValidLocale(locale) {
        if (locale && !ValidationUtils.isBlankString(locale)) {
            return (new RegExp(ValidationUtils.LOCALE_REGEX)).test(locale);
        }
        return false;
    }
    static isSafe(objectToEvaluate) {
        if (objectToEvaluate) {
            return true;
        }
        return false;
    }
    static isEmptyRecord(record) {
        if (!record) {
            return true;
        }
        return (Object.keys(record).length === 0);
    }
    static isValidBoolean(bool) {
        if (bool === null || bool === undefined) {
            return false;
        }
        return true;
    }
    static isValidUserIdRecord(record) {
        let evaluate = true;
        if (ValidationUtils.isEmptyRecord(record)) {
            return false;
        }
        if (record) {
            Object.keys(record).forEach((id) => {
                if (id !== ValidationUtils.CUSTOMER_ID && ValidationUtils.isBlankString(record[id])) {
                    evaluate = false;
                }
            });
        }
        return evaluate;
    }
}
exports.ValidationUtils = ValidationUtils;
ValidationUtils.CUSTOMER_ID = 'customerId';
ValidationUtils.LOCALE_REGEX = '^[A-Za-z-]*$';
